import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import toast from 'react-hot-toast';

export default function Contact() {
  return (
    <div className="min-h-screen bg-spice-light py-10 sm:py-20 pb-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        
        <div className="text-center mb-10 sm:mb-20">
          <div className="flex items-center justify-center gap-2 mb-3 sm:mb-4">
            <span className="h-[1px] w-8 bg-spice-red"></span>
            <span className="text-spice-red font-bold text-xs uppercase tracking-[0.2em]">Contact</span>
            <span className="h-[1px] w-8 bg-spice-red"></span>
          </div>
          <h1 className="text-3xl md:text-5xl font-serif font-bold text-spice-dark mb-3 sm:mb-4">Get In Touch</h1>
          <p className="text-sm sm:text-base md:text-lg text-spice-muted">Have questions? We'd love to hear from you.</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          
          <div className="bg-spice-surface border border-spice-border p-6 sm:p-10 rounded-2xl sm:rounded-none">
            <h2 className="text-xl md:text-2xl font-serif font-bold text-spice-dark mb-6 sm:mb-8">Reach Out directly</h2>
            
            <div className="space-y-6 sm:space-y-8">
              <div className="flex items-start">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center border border-spice-border mr-4 shadow-sm flex-shrink-0">
                  <span className="text-spice-red font-bold font-serif text-lg">P</span>
                </div>
                <div>
                  <h3 className="font-bold text-spice-dark uppercase tracking-widest text-xs mb-1">Head Office & Factory</h3>
                  <p className="text-spice-muted text-sm leading-relaxed">Ajjas food products,<br/>Industrial area, Ganjam,<br/>Srirangapatna Taluk, Mandya District-571477</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center border border-spice-border mr-4 shadow-sm flex-shrink-0">
                  <span className="text-spice-red font-bold font-serif text-lg">T</span>
                </div>
                <div>
                  <h3 className="font-bold text-spice-dark uppercase tracking-widest text-xs mb-1">Phone</h3>
                  <p className="text-spice-muted text-sm">+91 63600 37355</p>
                  <p className="text-xs text-opacity-70 text-spice-muted mt-1 uppercase">(Mon-Sat, 9 AM to 6 PM)</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center border border-spice-border mr-4 shadow-sm flex-shrink-0">
                  <span className="text-spice-red font-bold font-serif text-lg">E</span>
                </div>
                <div>
                  <h3 className="font-bold text-spice-dark uppercase tracking-widest text-xs mb-1">Email</h3>
                  <p className="text-spice-muted text-sm">enquiries@ajjasfoods.shop</p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2 bg-white p-6 sm:p-10 border border-spice-border rounded-2xl sm:rounded-none">
            <h2 className="text-xl md:text-2xl font-serif font-bold text-spice-dark mb-6 sm:mb-8">Send us a Message</h2>
            <form className="space-y-5 sm:space-y-6" onSubmit={(e) => {
                e.preventDefault();
                toast.success('Your message has been sent successfully.');
              }}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-xs font-bold uppercase tracking-widest text-spice-muted mb-2">Full Name</label>
                  <input required type="text" className="w-full px-4 py-3 border border-spice-border rounded-none focus:ring-0 focus:border-spice-red outline-none bg-spice-light font-sans" />
                </div>
                <div>
                  <label className="block text-xs font-bold uppercase tracking-widest text-spice-muted mb-2">Email Address</label>
                  <input required type="email" className="w-full px-4 py-3 border border-spice-border rounded-none focus:ring-0 focus:border-spice-red outline-none bg-spice-light font-sans" />
                </div>
              </div>
              
              <div>
                <label className="block text-xs font-bold uppercase tracking-widest text-spice-muted mb-2">Subject</label>
                <input required type="text" className="w-full px-4 py-3 border border-spice-border rounded-none focus:ring-0 focus:border-spice-red outline-none bg-spice-light font-sans" />
              </div>

              <div>
                <label className="block text-xs font-bold uppercase tracking-widest text-spice-muted mb-2">Your Message</label>
                <textarea required rows={5} className="w-full px-4 py-3 border border-spice-border rounded-none focus:ring-0 focus:border-spice-red outline-none bg-spice-light font-sans"></textarea>
              </div>

              <button type="submit" className="bg-spice-dark hover:bg-spice-red text-white py-4 px-8 rounded-none font-bold uppercase tracking-widest text-sm transition-colors mt-4">
                Send Message
              </button>
            </form>
          </div>

        </div>
      </div>
    </div>
  );
}
